module.exports = __webpack_public_path__ + "img/叉.e878854f.png";